import { Departement } from '../../models/departement';
import { DepartementHttp } from '../../models/departement-http';

export const fromDepartementHttpToDepartement = (departementHttp : DepartementHttp) : Departement => {
    return {
        code : departementHttp.code,
        name : departementHttp.label
    }
}
